import { patchState, signalStore, type, withHooks, withMethods } from '@ngrx/signals';
import { entityConfig, setAllEntities, withEntities } from '@ngrx/signals/entities';
import { inject } from '@angular/core';
import { distinctUntilChanged, first, map, tap } from 'rxjs';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { SkillAssignmentCore } from '@app/core/model/skill-assignment-core';
import { SkillAssignmentCoreApi } from '@app/core/services/api/skill-assignment-core.api';
import { setInitialized, withAsyncInitialization } from '@app/pages/home/tree/store/feature/async-initialization.feature';
import { TreeViewDataService } from '@app/core/services/tree-view.data.service';

const config = entityConfig({
  entity: type<SkillAssignmentCore>(),
  selectId: s => s.skillId,
});

export const SkillAssignmentsStore = signalStore(
  { providedIn: 'root' },
  withAsyncInitialization(),
  withEntities(config),
  withMethods((store, skillAssignmentCoreApi = inject(SkillAssignmentCoreApi), treeViewDataService = inject(TreeViewDataService)) => ({
    reload() {
      skillAssignmentCoreApi
        .fetchAll(treeViewDataService.$employeeView()?.uuid)
        .pipe(
          first(),
          map(allAssignments => allAssignments.filter(assignment => assignment.skillTitle !== 'root')),
          tap(allAssignments => patchState(store, setAllEntities(allAssignments, config), setInitialized())),
        )
        .subscribe();
    },
  })),
  withHooks({
    onInit(store, treeViewDataService = inject(TreeViewDataService)) {
      toObservable(treeViewDataService.$employeeView)
        .pipe(
          takeUntilDestroyed(),
          distinctUntilChanged(),
          tap(() => store.reload()),
        )
        .subscribe();
    },
  }),
);
